interface CardInfoProps {
  subHeading: string;
  heading: string;
}

const CardInfo = ({ subHeading, heading }: CardInfoProps) => {
  return (
    <div className="flex w-1/4 flex-col items-start justify-start gap-2">
      <div className="text-xs font-normal text-primaryGray-4">{subHeading}</div>
      <div className="text-sm font-bold text-primaryGray-1">{heading}</div>
    </div>
  );
};

export default CardInfo;
